import React from 'react';
import { GovSkeleton } from '@gov-design-system-ce/react';
import { useGlobalLocale } from '@gov-nx/core/service';
import { LayoutGap } from '@gov-nx/ui/web';

export const DrozdInfoSkeleton = () => {
	const { t } = useGlobalLocale();
	return (
		<LayoutGap gap="xl">
			<div className="flex flex-col gap-4 w-full p-8 border border-(--border-subtlest) rounded bg-(--background-neutral-white) [ md:flex-row ]">
				<GovSkeleton
					height="48px"
					width="48px"
					className="py-2"
					shape="circle"
					aria-label={t('loading.wcag.processing')}
				/>
				<div className="w-full">
					<GovSkeleton
						height="28px"
						width="70%"
						aria-label={t('loading.wcag.processing')}
						className="block mb-3"
					/>
					<GovSkeleton
						height="21px"
						width="100%"
						aria-label={t('loading.wcag.processing')}
					/>
					<GovSkeleton
						height="21px"
						width="90%"
						aria-label={t('loading.wcag.processing')}
					/>
					<GovSkeleton
						height="21px"
						width="98%"
						aria-label={t('loading.wcag.processing')}
					/>
					<GovSkeleton
						height="21px"
						width="70%"
						aria-label={t('loading.wcag.processing')}
					/>
					<div className="flex gap-4 mt-4">
						<GovSkeleton
							height="40px"
							width="160px"
							aria-label={t('loading.wcag.processing')}
						/>
						<GovSkeleton
							height="40px"
							width="175px"
							aria-label={t('loading.wcag.processing')}
						/>
					</div>
				</div>
			</div>
		</LayoutGap>
	);
};
